/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
import 'flickity-imagesloaded';

export function featuredSlider() {
  var slider = document.querySelector('.featured-articles-slider');
  var flkty = new Flickity(slider, {
    // options
    imagesLoaded: true,
    cellAlign: 'center',
    cellSelector: '.featuredArticle',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
    adaptiveHeight: false,
    autoPlay: 5000,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
          // Step 1: Remove is-hidden to open the space, but keep opacity 0
          slider.style.opacity = '0';
          slider.classList.remove('is-hidden');
          // Step 2: Wait for layout to settle, then fade in
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              slider.style.transition = 'opacity 0.4s ease';
              slider.style.opacity = '1';
            });
          });
        }, 1000);
      }
    }
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.featured-articles-slider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}

